export const TOP_TRADERS_TYPE_FILTER = [
  { text: 'WIDGETS_FILTERS.TOP_TRADERS_PROFIT_MADE', value: 'total_net_profit' },
  { text: 'WIDGETS_FILTERS.TOP_TRADERS_PROFIT_COPIERS', value: 'profit_copied_from' },
  { text: 'WIDGETS_FILTERS.TOP_TRADERS_SUCCESS_COPIERS', value: 'money_made_by_copying' },
  { text: 'WIDGETS_FILTERS.TOP_TRADERS_BONUS_EARNED', value: 'most_copy_bonus' },
  { text: 'WIDGETS_FILTERS.TOP_TRADERS_MANAGE_FUNDS', value: 'autocopy_margin_followed' },
];

export const TOP_TRADERS_TIME_SPAN_FILTER = [
  { text: 'WIDGETS_FILTERS.TOP_TRADERS_TODAY', value: 'last_day' },
  { text: 'WIDGETS_FILTERS.TOP_TRADERS_WEEK', value: 'last_week' },
  { text: 'WIDGETS_FILTERS.TOP_TRADERS_MONTH', value: 'last_1_month' },
  { text: 'WIDGETS_FILTERS.TOP_TRADERS_ALL', value: 'all_time' },
];

export const TOP_WINS_TIME_SPAN_FILTER = [
  { text: 'WIDGETS_FILTERS.TOP_WINS_DAY', value: 'top_wins_last_day' },
  { text: 'WIDGETS_FILTERS.TOP_WINS_WEEK', value: 'top_wins_last_week' },
  { text: 'WIDGETS_FILTERS.TOP_WINS_MONTH', value: 'top_wins_last_month' },
];

export const WIDGETS = [
  {
    label: 'WIDGETS.TOP_TRADERS',
    value: 1,
  },
  {
    label: 'WIDGETS.TOP_WINS',
    value: 2,
  },
];



// WEBPACK FOOTER //
// ./src/app/main/widgets/constants/widget-constants.js